// The static fallback, outside `RootErrorBoundary.tsx` (Generator ADR 30.10.26w).
//
// `wasm/report.ts` reveals it, and `wasm/index.ts` reaches `report.ts`, and the
// proof-of-work worker (`auth/pow.worker.ts`) imports `wasm/index.ts`. Under
// `vite dev` every `.tsx` module is instrumented for React Refresh, whose
// runtime touches `window` at module scope — so a `.tsx` anywhere on that chain
// throws `window is not defined` inside the worker, and the first sign-in
// through `make dev-web` never posts `/auth/login`. A production build carries
// no refresh runtime, which is why only the dev server ever showed it.
// `wasm/__tests__/importGraph.test.ts` keeps the chain `.tsx`-free.

const FATAL_TEMPLATE_ID = 'fatal'
const ROOT_ID = 'root'

/**
 * Reveal the static fallback markup `index.html` shipped.
 *
 * A `cloneNode` of a `<template>` that was parsed before any module evaluated,
 * so it survives a bundle that failed to execute. If the template is missing
 * too — an `index.html` this repo did not build — a bare text node is still
 * better than a blank page.
 *
 * Exported since ADR 11.9.26a §1: a recorded wasm init failure reveals this
 * same template from `wasm/report.ts` and renders nothing. No markup change and
 * no new string — what changed is only that the fallback is reached at all.
 */
export function revealFatal(): void {
  const host = document.getElementById(ROOT_ID) ?? document.body
  const template = document.getElementById(FATAL_TEMPLATE_ID)
  host.replaceChildren()
  if (template instanceof HTMLTemplateElement) {
    host.appendChild(template.content.cloneNode(true))
    return
  }
  host.textContent = 'Lingara could not start.'
}
